import type React from 'react';

import type { IconProps } from 'types/icon';

const LetterUnread: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M18.3337 8.33331C18.3491 8.9392 18.3337 9.21184 18.3337 9.99998C18.3337 13.1427 18.3337 14.714 17.3573 15.6903C16.381 16.6666 14.8097 16.6666 11.667 16.6666H8.33366C5.19096 16.6666 3.61961 16.6666 2.6433 15.6903C1.66699 14.714 1.66699 13.1427 1.66699 9.99998C1.66699 6.85728 1.66699 5.28593 2.6433 4.30962C3.61961 3.33331 5.19096 3.33331 8.33366 3.33331H10.8337"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5 6.66669L6.79908 8.16592C8.32961 9.44136 9.09488 10.0791 10 10.0791C10.9051 10.0791 11.6704 9.44136 13.2009 8.16592"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        cx="15.833"
        cy="4.16669"
        r="2.5"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default LetterUnread;
